"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getNavItemNameFromIntlText = void 0;
const getNavItemNameFromIntlText = text => {
  if (!text) return '';
  const textParts = text.split('.');
  return textParts[textParts.length - 1];
};
exports.getNavItemNameFromIntlText = getNavItemNameFromIntlText;